import { ChevronRight } from 'lucide-react'
import { KLabel } from './card'

/**
 * Metric tile — severity carried by the figure itself: a short warm→cool rule
 * under the number + a state word. No left accent rail.
 */
export function MetricTile({
  label,
  value,
  unit,
  tone,
  state,
  onDrill,
}: {
  label: string
  value: string
  unit?: string
  /** CSS colour for the underline + state word (e.g. riskColor(v)) */
  tone: string
  state?: string
  onDrill?: () => void
}) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <KLabel>{label}</KLabel>
      <div className="mt-2 font-display text-[29px] font-semibold leading-none tracking-tight tabular">
        {value}
        {unit && <span className="text-[13px] font-medium text-muted-foreground"> {unit}</span>}
      </div>
      <div className="mt-3 h-[3px] w-9 rounded" style={{ background: tone }} />
      {state && (
        <div className="mt-2 text-[11.5px] font-semibold" style={{ color: tone }}>
          {state}
        </div>
      )}
      {onDrill && (
        <button
          onClick={onDrill}
          className="mt-2 flex items-center gap-1 text-[11.5px] text-muted-foreground hover:text-foreground"
        >
          <ChevronRight className="size-3" /> drill to evidence
        </button>
      )}
    </div>
  )
}
